import React from 'react'
import { useRoutes as routerUseRoutes } from 'react-router-dom'
import { BrowserLanguageDetector } from '../components/localization/browser-language-detector'
import FormPage from '../pages/form'
import RepairKitPage from '../pages/repair-kit'

const useRoute = (): React.ReactElement | null => {
  return routerUseRoutes([
    //{ path: '/:lang/recall-status/:serialNumber', element: <RecallStatusPage /> },
    { path: '/repair-kit', element: <BrowserLanguageDetector redirectTo="repair-kit" /> },
    { path: '/form', element: <BrowserLanguageDetector /> },
    { path: '/:lang/repair-kit', element: <RepairKitPage /> },
    { path: '/:lang', element: <FormPage /> },
    { path: '/:lang/form', element: <FormPage /> },
    { path: '/', element: <BrowserLanguageDetector /> },
  ])
}

export default useRoute
